import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, arraysAreEqual, } from "../CommonComponents/CustomHooks";
import { OperationalTable } from "../CommonComponents/OperationalTable";
import { FormButton } from "../CommonComponents/InputBox";

const UnBagging = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [scanNo, setScanNo] = useState('')
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [CheckAll, setCheckAll] = useState(false)
    const [tableData, setTableData] = useState([])
    const [formData, setFormData] = useState({
        awbNoList: []
    });

    const handleUnBagging = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/UnbaggingEntry', { awbNo: (formData.awbNoList).toString() })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    }

    const handleClear = () => {
        setFormData({
            awbNoList: []
        })
        getUnManifestAwbNoDetail()
    }
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const getUnManifestAwbNoDetail = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetUnManifestDetail', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }


    const handleCheck = (id, awbNo) => {
        const updatedAwbNoList = [...formData.awbNoList];
        const index = updatedAwbNoList.indexOf(awbNo);

        if (index !== -1) {
            updatedAwbNoList.splice(index, 1);
        } else {
            updatedAwbNoList.push(awbNo);
        }
        setFormData({ ...formData, awbNoList: updatedAwbNoList });
    };

    const handleCheckAll = (value) => {
        setCheckAll(value);
        const updatedTableData = tableData?.Data.map(item => {
            return {
                ...item,
                checkStatus: value
            };
        });
        setTableData(prevCNResult => ({
            ...prevCNResult,
            Data: updatedTableData
        }));
        const updatedAwbNoList = value ? tableData?.Data.map(item => item.AwbNo) : [];
        let updatedPcs = value ? tableData?.Data.map(item => item.PCS) : [];
        updatedPcs = updatedPcs?.reduce((total, currentValue) => total + Number(currentValue), 0);
        let updatedActWgt = value ? tableData?.Data.map(item => item.Weight) : [];
        updatedActWgt = updatedActWgt?.reduce((total, currentValue) => total + Number(currentValue), 0);
        setFormData({
            ...formData, awbNoList: updatedAwbNoList,
            pcs: updatedPcs ? updatedPcs.toString() : '',
            weight: updatedActWgt ? updatedActWgt.toString() : ''
        });
    };

    const HandleScanData = async () => {
        if (!scanNo) {
            await NotificationSound('ERROR', 'Please enter Awb No.!', 'txtAwbNo', inputrefs);
            return;
        } else {
            let isAvaialble = tableData?.Data?.filter(item => item.AwbNo === scanNo).length;
            if (isAvaialble) {
                let tableData1 = tableData.Data.map(item => {
                    if (scanNo === item.AwbNo && item.checkStatus === false) {
                        return {
                            ...item,
                            checkStatus: true
                        }
                    } else {
                        return {
                            ...item,
                            checkStatus: item.checkStatus ? item.checkStatus : false
                        }
                    }
                })
                setScanNo('')
                const updatedList = tableData1?.filter(item => item.checkStatus).map(item => item.AwbNo) || [];
                setFormData({ ...formData, awbNoList: [...updatedList] })
            } else {
                setScanNo('')
                await NotificationSound('ERROR', 'AwbNo Not Found!', 'txtAwbNo', inputrefs);
                return;
            }
        }
    }
    const handleChange1 = (event, value) => {
        getUnManifestAwbNoDetail(value);
    };
    useEffect(() => {
        let newTableData = tableData?.Data?.map(item => {
            const checkStatus = formData?.awbNoList?.some(awb => item.AwbNo === awb) ? true : false;
            return { ...item, checkStatus };
        });
        let newCheckedData = newTableData?.filter(item => item.checkStatus)
        let updatedPcs = newCheckedData?.map(item => item.PCS)
        updatedPcs = updatedPcs?.reduce((total, currentValue) => total + Number(currentValue), 0);
        let updatedActWgt = newCheckedData?.map(item => item.Weight)
        updatedActWgt = updatedActWgt?.reduce((total, currentValue) => total + Number(currentValue), 0);
        setFormData({
            ...formData,
            pcs: updatedPcs ? updatedPcs.toString() : '',
            weight: updatedActWgt ? updatedActWgt.toString() : ''
        });

        if (!arraysAreEqual(newTableData, tableData.Data)) {
            setTableData(CNResult => ({
                ...tableData, Data: newTableData,
                HideColumns: CNResult?.HideColumns ? [...CNResult?.HideColumns, 'checkStatus', 'Checkbox'] : ['checkStatus','Checkbox']
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData.Data, formData.awbNoList]);

    useEffect(() => {
       
        document.title = 'Un-Bagging'
    }, [])
    useEffect(() => {
        getUnManifestAwbNoDetail()
    }, [sortConfig])
    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 pb-3 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Un-Bagging')}</span>
                    </div>
                    <div className='card-body pb-1'>
                        <FormButton
                            Export={false}
                            handleSubmit={handleUnBagging}
                            handleClear={handleClear}
                        />
                    </div>
                    <OperationalTable
                        PageName={'UnBagging'}
                        inputPlaceHolder='Awb No'
                        showCheckBox={true}
                        Filter={false}
                        loading={isLoading}
                        handleCheck={handleCheck}
                        handleCheckAll={handleCheckAll}
                        CheckAll={CheckAll}
                        tableData={tableData}
                        currentPageNo={currentPageNo}
                        cnNo={scanNo}
                        setcnNo={setScanNo}
                        HandleScanList={HandleScanData}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                        handleChange1={handleChange1}
                    />
                </div>
            </div>

        </>
    )
}
export default UnBagging